import React from "react";
import Pagination from "@mui/material/Pagination";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import moment from "moment";
import { useSelector } from "react-redux";

import "../../assets/style/tablesG.css";


/* import { CardTotalClienteList } from "../pptos/form/CardTotalClienteList";
import { CardGastoRList } from "../pptos/form/CardGastoRList";
import { CardUtilidadRealList } from "../pptos/form/CardUtilidadRealList"; */
// import { CardUtilidadFinalList } from "../pptos/form/CardUtilidadFinalList"
import { Tooltip } from "@mui/material";
import { BoxTotalsProfit } from "../pptos/list/BoxTotalsProfit";

export const TableListAprobados = ({ filters, setFilters }) => {
  //const isMobile = useMediaQuery('(max-width:768px)');
  const { access } = useSelector((state) => state.auth);
  /*   const paramsDetail = useSelector((state) => state.general.detail); */

  const { list } = useSelector((state) => state.ppto);
  const { cantidad } = useSelector((state) => state.ppto.totales);


  const handleChange = (event, value) => {
    /* console.log(value) */
    const newFilters = {
      ...filters,
      page: value,
    };
    setFilters(newFilters);
  };

  return (
    <>
      {/* {perfil !== 9 && (
        <div className="grid grid-cols-1 md:grid-cols-3 mt-3 md:gap-3">
          <div>
            <CardTotalClienteList params={paramsDetail} />
          </div>
          <div>{access.a22 && <CardGastoRList params={paramsDetail} />}</div>
          <div>
            {access.a23 && <CardUtilidadRealList params={paramsDetail} />}
          </div>
        </div>
      )}
 */}
      <BoxTotalsProfit />

      <div className="p-table">
        <div className="flex justify-between items-center">
          {cantidad > 0 ? (
            <div className="ms-2 text-gray-500">
              {cantidad || 0} proyectos encontrados
            </div>
          ) : (
            <div></div>
          )}

          <Pagination
            count={Math.max(1, Math.ceil(Number(cantidad || 0) / filters.rows))}
            page={Number(filters.page) || 1}
            size="small"
            onChange={handleChange}
          />
        </div>

        <div className="overflow-x-auto">
          <table className="table p-table-global">
            <thead className="p-thead-global">
              <tr className="text-center">
                <th colSpan={5} className="text-end"></th>

                {/* {perfil !== 9 && */}
                <th
                  className="text-center"
                  style={{
                    borderLeft: "1px solid lightgray",
                    color: "#595759",
                  }}
                >
                  VENTA
                </th>
                {/*  } */}

                {access.a20 && (
                  <th
                    colSpan={2}
                    style={{
                      borderLeft: "1px solid lightgray",
                      color: "#595759",
                    }}
                  >
                    PRESUPUESTO
                  </th>
                )}

                {access.a22 && (
                  <th
                    colSpan={2}
                    style={{
                      borderLeft: "1px solid lightgray",
                      color: "#595759",
                    }}
                  >
                    REAL / ACTUAL
                  </th>
                )}

                {access.a23 && (
                  <th
                    colSpan={2}
                    style={{
                      borderLeft: "1px solid lightgray",
                      color: "#595759",
                    }}
                  >
                    PROYECTADO
                  </th>
                )}

                {/* {access.a20 &&
                    <th style={{ borderLeft: '1px solid lightgray' }}></th>
                } */}

                {access.a10 && (
                  <th
                    colSpan={2}
                    style={{
                      borderLeft: "1px solid lightgray",
                      color: "#595759",
                    }}
                  >
                    FACTURACIÓN
                  </th>
                )}
              </tr>
              <tr className="text-center">
                <th style={{ color: "#595759" }}>Número</th>
                <th style={{ color: "#595759" }}>Fecha</th>
                <th style={{ color: "#595759" }}>Ejecutivo</th>
                <th
                  className="text-start sticky left-0 z-10 bg-white"
                  style={{ color: "#595759" }}
                >
                  Referencia
                </th>
                <th
                  className="text-start min-w-60"
                  style={{ color: "#595759" }}
                >
                  Cliente
                </th>

                {/*  {perfil !== 9 && */}
                <th
                  style={{
                    borderLeft: "1px solid lightgray",
                    color: "#595759",
                  }}
                  className="min-w-28"
                >
                  Total Neto
                </th>
                {/*  } */}

                {access.a20 && (
                  <>
                    <th
                      style={{
                        borderLeft: "1px solid lightgray",
                        color: "#595759",
                      }}
                    >
                      Costos
                    </th>
                    <th style={{ color: "#595759" }}>Rentabilidad</th>
                  </>
                )}

                {access.a22 && (
                  <>
                    <th
                      style={{
                        borderLeft: "1px solid lightgray",
                        color: "#595759",
                      }}
                    >
                      Gasto real
                    </th>
                    <th style={{ color: "#595759" }}>Rentabilidad</th>
                  </>
                )}

                {access.a23 && (
                  <>
                    <th
                      style={{
                        borderLeft: "1px solid lightgray",
                        color: "#595759",
                      }}
                    >
                      Por gastar
                    </th>
                    <th style={{ color: "#595759" }}>Rentabilidad</th>
                  </>
                )}

                {/* {access.a20 &&
                                    <th style={{ borderLeft: '1px solid lightgray', color: '#595759' }}>Eficiencia</th>
                                } */}

                {access.a10 && (
                  <>
                    <th
                      style={{
                        borderLeft: "1px solid lightgray",
                        color: "#595759",
                      }}
                    >
                      Facturado
                    </th>
                    <th style={{ color: "#595759" }}>Por facturar</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {list.map((p) => (
                <tr className="p-tr-body-global" key={p.id}>
                  <td className="text-center align-start">
                    <Link
                      className="LinkTable text-[11px]"
                      to={`/projects/${p.id}`}
                    >
                      #{p.numero}
                    </Link>
                  </td>
                  <td
                    className="text-center align-start"
                    title={moment(p.fecha_asignacion).format("DD-MM-YYYY")}
                  >
                    <Link
                      className="LinkTable text-[11px]"
                      to={`/projects/${p.id}`}
                    >
                      {moment(p.fecha_asignacion).format("MMM YYYY")}
                    </Link>
                  </td>
                  <td>
                    <Link className="LinkTable" to={`/projects/${p.id}`}>
                      <div className="row photo scale-90">
                        <div className="col d-flex justify-content-center">
                          <div className="d-flex justify-content-center align-items-center p-container-foto">
                            <Tooltip
                              title={`${p.ejecutivo_nombre}${" "}${p.ejecutivo_apellidos}`}
                            >
                              <span>
                                {p.ejecutivo_nombre
                                  ? p.ejecutivo_nombre.substring(0, 1)
                                  : ""}
                                {p.ejecutivo_apellidos
                                  ? p.ejecutivo_apellidos.substring(0, 1)
                                  : ""}
                              </span>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </td>
                  <td className="text-clientes text-start align-start sticky left-0 z-10 bg-white">
                    <Link
                      className="LinkTable text-[11px]"
                      to={`/projects/${p.id}`}
                    >
                      {p.referencia || "---"}
                    </Link>
                    {p.estado_cierre !== "abierto" &&
                    p.estado_cierre !== "" &&
                    p.estado_cierre !== null ? (
                      <div style={{ marginBottom: "-18px" }}>
                        <span className={`p-label-${p.estado_cierre}-list`}>
                          {p.estado_cierre === "cerrado" && (
                            <i className="bi bi bi-lock"></i>
                          )}
                          {p.estado_cierre === "pausado" && (
                            <i className="bi bi-pause-circle"></i>
                          )}
                          <label className="ms-1">{p.estado_cierre}</label>
                        </span>
                      </div>
                    ) : (
                      ""
                    )}
                  </td>
                  <td className="text-clientes text-start align-start">
                    <Link
                      className="LinkTable text-[11px]"
                      to={`/projects/${p.id}`}
                    >
                      {p.cliente || "---"}
                    </Link>
                  </td>

                  {/* venta */}
                  <td
                    className="text-center align-bottom"
                    style={{ borderLeft: "1px solid lightgray" }}
                  >
                    <Link className="LinkTable" to={`/projects/${p.id}`}>
                      <div className="text-[12px] font-bold text-[#3e80ff]">
                        <NumberFormat
                          value={p.total_neto ? parseFloat(p.total_neto) : 0}
                          displayType={"text"}
                          thousandSeparator={p.separacion_miles}
                          decimalSeparator={p.separacion_decimales}
                          decimalScale={2}
                          prefix={`${p.simbolo} `}
                          fixedDecimalScale
                        />
                      </div>
                    </Link>
                  </td>

                  {access.a20 && <InitialInfo p={p} />}

                  {access.a22 && <ActualInfo p={p} />}

                  {access.a23 && <FutureInfo p={p} />}

                  {/* {access.a20 &&
                                        <EficienciaInfo p={p} />
                                    } */}

                  {access.a10 && <FacturacionInfo p={p} />}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

const InitialInfo = ({ p }) => {
  return (
    <>
      <td
        className="text-end align-bottom"
        style={{ borderLeft: "1px solid lightgray" }}
      >
        <Link className="LinkTable" to={`/projects/${p.id}`}>
          <div className="text-[11px] text-red-400">
            <NumberFormat
              value={p.margen_gasto_p ? parseFloat(p.margen_gasto_p) : 0}
              displayType={"text"}
              thousandSeparator={","}
              decimalSeparator="."
              decimalScale={2}
              fixedDecimalScale
              suffix=" %"
            />
          </div>
          <div className="text-[12px] font-bold text-red-400">
            <NumberFormat
              value={p.total_gasto_p ? parseFloat(p.total_gasto_p) : 0}
              displayType={"text"}
              thousandSeparator={p.separacion_miles}
              decimalSeparator={p.separacion_decimales}
              decimalScale={2}
              prefix={`${p.simbolo} `}
              fixedDecimalScale
            />
          </div>
        </Link>
      </td>
      <td className="text-end align-bottom">
        <Link className="LinkTable" to={`/projects/${p.id}`}>
          <div className="text-[11px] text-green-500">
            <NumberFormat
              value={p.rentabilidad_p ? parseFloat(p.rentabilidad_p) : 0}
              displayType={"text"}
              thousandSeparator={","}
              decimalSeparator="."
              decimalScale={2}
              suffix=" %"
              fixedDecimalScale
            />
          </div>
          <div className="text-[12px] font-bold text-green-500">
            <NumberFormat
              value={p.total_utilidad_p ? parseFloat(p.total_utilidad_p) : 0}
              displayType={"text"}
              thousandSeparator={p.separacion_miles}
              decimalSeparator={p.separacion_decimales}
              decimalScale={2}
              prefix={`${p.simbolo} `}
              fixedDecimalScale
            />
          </div>
        </Link>
      </td>
    </>
  );
};

const ActualInfo = ({ p }) => {
  return (
    <>
      <td
        className="text-end align-bottom"
        style={{ borderLeft: "1px solid lightgray" }}
      >
        <Link className="LinkTable" to={`/projects/${p.id}`}>
          <div className="text-[11px] text-red-600">
            <NumberFormat
              className=""
              value={p.margen_gasto_r ? parseFloat(p.margen_gasto_r) : 0}
              displayType={"text"}
              thousandSeparator={","}
              decimalSeparator="."
              decimalScale={2}
              suffix=" %"
              fixedDecimalScale
            />
          </div>
          <div className="text-[12px] font-bold text-red-600">
            <NumberFormat
              value={p.total_gasto_r ? parseFloat(p.total_gasto_r) : 0}
              displayType={"text"}
              thousandSeparator={p.separacion_miles}
              decimalSeparator={p.separacion_decimales}
              decimalScale={2}
              prefix={`${p.simbolo} `}
              fixedDecimalScale
            />
          </div>
        </Link>
      </td>
      <td className="text-end align-bottom">
        <Link className="LinkTables" to={`/projects/${p.id}`}>
          <div className="text-[11px] text-green-600">
            <NumberFormat
              value={p.margen_utilidad_r ? parseFloat(p.margen_utilidad_r) : 0}
              displayType={"text"}
              thousandSeparator={","}
              decimalSeparator="."
              decimalScale={2}
              suffix=" %"
              fixedDecimalScale
            />
          </div>
          <div className="text-[12px] font-bold text-green-600">
            <NumberFormat
              value={p.total_utilidad_r ? parseFloat(p.total_utilidad_r) : 0}
              displayType={"text"}
              thousandSeparator={p.separacion_miles}
              decimalSeparator={p.separacion_decimales}
              decimalScale={2}
              prefix={`${p.simbolo} `}
              fixedDecimalScale
            />
          </div>
        </Link>
      </td>
    </>
  );
};

const FutureInfo = ({ p }) => {
  return (
    <>
      <td
        className="text-end align-bottom"
        style={{ borderLeft: "1px solid lightgray" }}
      >
        <Link className="LinkTable" to={`/projects/${p.id}`}>
          <div
            className="text-[11px]"
            style={{ color: parseFloat(p.total_por_gastar) < 0 ? "red" : "" }}
          >
            <NumberFormat
              value={p.margen_por_gastar ? parseFloat(p.margen_por_gastar) : 0}
              displayType={"text"}
              thousandSeparator={","}
              decimalSeparator="."
              decimalScale={2}
              suffix=" %"
              fixedDecimalScale
            />
          </div>
          <div
            className="text-[12px] font-bold"
            style={{ color: parseFloat(p.total_por_gastar) < 0 ? "red" : "" }}
          >
            <NumberFormat
              value={p.total_por_gastar ? parseFloat(p.total_por_gastar) : 0}
              displayType={"text"}
              thousandSeparator={p.separacion_miles}
              decimalSeparator={p.separacion_decimales}
              decimalScale={2}
              prefix={`${p.simbolo} `}
              fixedDecimalScale
            />
          </div>
        </Link>
      </td>
      <td className="text-end align-bottom">
        <Link className="LinkTable" to={`/projects/${p.id}`}>
          <div className="text-[11px] text-green-800">
            <NumberFormat
              value={p.margen_proyectado ? parseFloat(p.margen_proyectado) : 0}
              displayType={"text"}
              thousandSeparator={","}
              decimalSeparator="."
              decimalScale={2}
              suffix=" %"
              fixedDecimalScale
            />
          </div>
          <div className="text-[12px] font-bold text-green-800">
            <NumberFormat
              value={
                p.total_utilidad_proyectado
                  ? parseFloat(p.total_utilidad_proyectado)
                  : 0
              }
              displayType={"text"}
              thousandSeparator={p.separacion_miles}
              decimalSeparator={p.separacion_decimales}
              decimalScale={2}
              prefix={`${p.simbolo} `}
              fixedDecimalScale
            />
          </div>
        </Link>
      </td>
    </>
  );
};

// const EficienciaInfo = ({ p }) => {
//     return (
//         <td className='text-center align-bottom' style={{ borderLeft: '1px solid lightgray' }}>
//             <Link className='LinkTable' to={`/projects/${p.id}`} >
//                 <div className="p-numbers-list text-center" style={{ color: parseFloat(p.porcentaje_eficiencia) < 0 ? 'red' : '' }}>
//                     <NumberFormat
//                         value={p.porcentaje_eficiencia ? parseFloat(p.porcentaje_eficiencia).toFixed(2) : 0}
//                         displayType={'text'}
//                         thousandSeparator={','}
//                         decimalSeparator='.'
//                         decimalScale={0}
//                         suffix=" %"
//                     />
//                 </div>
//             </Link>
//         </td>
//     )
// }

const FacturacionInfo = ({ p }) => {
  return (
    <>
      <td
        className="text-end align-bottom"
        style={{ borderLeft: "1px solid lightgray" }}
      >
        <Link className="LinkTable" to={`/projects/${p.id}`}>
          <div className="text-[11px]">
            <NumberFormat
              value={
                p.total_facturado
                  ? (parseFloat(p.total_facturado) / parseFloat(p.total_neto)) *
                    100
                  : 0
              }
              displayType={"text"}
              thousandSeparator={","}
              decimalSeparator="."
              decimalScale={2}
              suffix=" %"
              fixedDecimalScale
            />
          </div>
          <div className="text-[12px] font-bold">
            <NumberFormat
              value={p.total_facturado ? parseFloat(p.total_facturado) : 0}
              displayType={"text"}
              thousandSeparator={p.separacion_miles}
              decimalSeparator={p.separacion_decimales}
              decimalScale={2}
              prefix={`${p.simbolo} `}
              fixedDecimalScale
            />
          </div>
        </Link>
      </td>
      <td className="text-end align-bottom">
        <Link className="LinkTable" to={`/projects/${p.id}`}>
          <div className="text-[11px]">
            <NumberFormat
              value={
                p.total_facturado
                  ? 100 -
                    (parseFloat(p.total_facturado) / parseFloat(p.total_neto)) *
                      100
                  : 0
              }
              displayType={"text"}
              thousandSeparator={","}
              decimalSeparator="."
              decimalScale={2}
              suffix=" %"
              fixedDecimalScale
            />
          </div>
          <div className="text-[12px] font-bold">
            <NumberFormat
              value={
                p.total_por_facturar ? parseFloat(p.total_por_facturar) : 0
              }
              displayType={"text"}
              thousandSeparator={p.separacion_miles}
              decimalSeparator={p.separacion_decimales}
              decimalScale={2}
              prefix={`${p.simbolo} `}
              fixedDecimalScale
            />
          </div>
        </Link>
      </td>
    </>
  );
};
